import { extendTheme } from '@chakra-ui/react';

// IRORIブランドに合わせたカスタムテーマ
const chakraTheme = extendTheme({
  colors: {
    // IRORIメインカラー（既存のTailwindテーマと合わせる）
    irori: {
      50: '#FFF7ED',
      100: '#FFEDD5',
      200: '#FED7AA',
      300: '#FDBA74',
      400: '#FB923C',
      500: '#F97316',
      600: '#EA580C', // メインカラー
      700: '#C2410C',
      800: '#9A3412',
      900: '#7C2D12',
    },
    // ゴールドアクセント
    gold: {
      50: '#FFFBEB',
      100: '#FEF3C7',
      200: '#FDE68A',
      300: '#FCD34D',
      400: '#FBBF24',
      500: '#F59E0B',
      600: '#D97706',
      700: '#B45309',
      800: '#92400E',
      900: '#78350F',
    },
    // ブランドプライマリとしてオレンジを設定
    brand: {
      50: '#FFF7ED',
      100: '#FFEDD5',
      200: '#FED7AA',
      300: '#FDBA74',
      400: '#FB923C',
      500: '#F97316',
      600: '#EA580C',
      700: '#C2410C',
      800: '#9A3412',
      900: '#7C2D12',
    }
  },
  fonts: {
    heading: `'Noto Serif JP', serif`,
    body: `'Inter', system-ui, sans-serif`,
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
    '7xl': '4.5rem',
    '8xl': '6rem',
    '9xl': '8rem',
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'medium',
        borderRadius: 'lg',
        transition: 'all 0.2s',
        _focus: {
          boxShadow: '0 0 0 3px rgba(234, 88, 12, 0.6)',
        }
      },
      variants: {
        // IRORIプライマリボタン
        primary: {
          bg: 'irori.500',
          color: 'white',
          _hover: {
            bg: 'irori.600',
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
            _disabled: {
              bg: 'irori.500',
              transform: 'none',
              boxShadow: 'none',
            },
          },
          _active: {
            bg: 'irori.700',
            transform: 'translateY(0)',
          },
        },
        // セカンダリボタン
        secondary: {
          borderWidth: '2px',
          borderColor: 'irori.500',
          color: 'irori.500',
          bg: 'transparent',
          _hover: {
            bg: 'irori.500',
            color: 'white',
          },
        },
        // アウトラインボタン（ヒーロー用）
        outline: {
          borderWidth: '2px',
          borderColor: 'white',
          color: 'white',
          bg: 'transparent',
          _hover: {
            bg: 'white',
            color: 'gray.900',
          },
        },
        // ゴーストボタン
        ghost: {
          color: 'gray.600',
          _hover: {
            color: 'irori.500',
            bg: 'irori.50',
          },
        }
      },
      sizes: {
        sm: {
          px: 4,
          py: 2,
          fontSize: 'sm',
        },
        md: {
          px: 6,
          py: 3,
          fontSize: 'md',
        },
        lg: {
          px: 8,
          py: 4,
          fontSize: 'lg',
        },
      },
      defaultProps: {
        variant: 'primary',
        size: 'md',
      },
    },
    Heading: {
      baseStyle: {
        fontFamily: 'heading',
        fontWeight: 'bold',
      },
      variants: {
        hero: {
          fontSize: ['4xl', '5xl', '6xl'],
          lineHeight: 'shorter',
          color: 'white',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
        },
        section: {
          fontSize: ['2xl', '3xl', '4xl'],
          color: 'gray.800',
          textAlign: 'center',
          mb: 6,
        }
      }
    },
    Card: {
      baseStyle: {
        bg: 'white',
        borderRadius: 'xl',
        boxShadow: 'lg',
        overflow: 'hidden',
        transition: 'all 0.3s',
        _hover: {
          transform: 'translateY(-4px)',
          boxShadow: '2xl',
        }
      }
    },
    Badge: {
      variants: {
        premium: {
          bg: 'gold.100',
          color: 'gold.800',
          borderRadius: 'full',
          px: 3,
          py: 1,
          fontSize: 'sm',
          fontWeight: 'medium',
        }
      }
    }
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
      },
      '*': {
        borderColor: 'gray.200',
      }
    }
  },
  breakpoints: {
    sm: '30em', // 480px
    md: '48em', // 768px
    lg: '62em', // 992px
    xl: '80em', // 1280px
    '2xl': '96em', // 1536px
  }
});

export default chakraTheme;